import { useQuery } from '@tanstack/react-query';

import { GetTokenResponse } from '@/api/sofarApi/types';
import { RequestOptions, axios } from '@/common/axios';
import { ExtractFnReturnType, QueryConfig } from '@/common/react-query';

export const getApiToken = async (options?: RequestOptions): Promise<GetTokenResponse> => {
    return axios.get<GetTokenResponse, GetTokenResponse>('/fetch/get-token', options);
};

type QueryFnType = typeof getApiToken;

type UseApiTokenOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useApiToken = ({ config }: UseApiTokenOptions = {}) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['sofar-api-token'],
        queryFn: ({ signal }) => getApiToken({ signal }),
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};
